import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import { taskAttachmentSchema } from "@backend/src/schemas/taskSchema";
import ApiRequest from "../ApiRequest";

type UseAttachmentUpdateResponse = ResponseType<null>;

function useAttachmentUpdateMutation(id: string) {
  const mutation = useMutation<
    AxiosResponseAndError<UseAttachmentUpdateResponse>["response"],
    AxiosResponseAndError<UseAttachmentUpdateResponse>["error"],
    z.infer<typeof taskAttachmentSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.put<UseAttachmentUpdateResponse>(
        requestURLs.task+"attachment-update/" + id,
        data
      ),
  });

  return mutation;
}

export default useAttachmentUpdateMutation;
